import { render, staticRenderFns } from "./AdminCourseEditLog.vue?vue&type=template&id=f4503300"
import script from "./AdminCourseEditLog.vue?vue&type=script&lang=js"
export * from "./AdminCourseEditLog.vue?vue&type=script&lang=js"
import style0 from "./AdminCourseEditLog.vue?vue&type=style&index=0&id=f4503300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports